import { ReactNode } from "react";
import {
  CircularProgress,
  Dialog,
  Divider,
  Grid,
  SxProps,
  Theme,
} from "@mui/material";
import { HorizontalCenterDiv } from "@/common/divs";
import { AlmostBoldText } from "@/common/texts";
import { CloseButtonIcon } from "@/components/icons";
import { NEUTRO_BLANK_COLOR } from "@/utils/constants";

export const CustomDialog = ({
  title,
  open,
  handleClose,
  isLoading = false,
  children,
  sx = {},
  actions = null,
}: {
  title: string;
  open: boolean;
  handleClose: () => void;
  isLoading?: boolean;
  children: ReactNode;
  sx?: SxProps<Theme>;
  actions?: ReactNode;
}) => {
  return (
    <Dialog
      onClose={handleClose}
      open={open}
      sx={{
        ...sx,
        "& .MuiPaper-root": {
          borderRadius: "16px 12px 16px 12px",
          backgroundColor: NEUTRO_BLANK_COLOR,
          minWidth: {
            xs: "80vw",
            sm: "80vw",
            md: "65vw",
          },
        },
      }}
    >
      <Grid
        container
        sx={{
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          padding: "24px",
          backgroundColor: NEUTRO_BLANK_COLOR,
        }}
      >
        {isLoading ?
          <HorizontalCenterDiv width="100%" paddingY="26px">
            <CircularProgress color="primary" size={24} />
          </HorizontalCenterDiv>
        : <>
            <Grid
              item
              xs={12}
              sx={{
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <>
                <AlmostBoldText
                  fontSize={"24px"}
                  style={{ textAlign: "center", marginLeft: "auto" }}
                >
                  {title}
                </AlmostBoldText>
                <CloseButtonIcon
                  handleClick={() => {
                    handleClose();
                  }}
                  sx={{
                    width: "32px",
                    height: "32px",
                    cursor: "pointer",
                    marginLeft: "auto",
                    float: "right",
                  }}
                />
              </>
            </Grid>
            <Grid item xs={12}>
              {children}
            </Grid>
          </>
        }
      </Grid>
      {actions ?
        <>
          <Divider sx={{ width: "100%" }}></Divider>
          <Grid container sx={{ paddingY: "16px", paddingX: "24px" }}>
            {actions}
          </Grid>
        </>
      : null}
    </Dialog>
  );
};
